
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Types.js";
import { Bruch__GetGgt, Bruch__IstKürzbarMit_Z524259A4, Bruch__IstGekürzt, Bruch_ErstelleZufälligenBruch_ZC341D2B, Bruch_Create_Z37302880, BruchEditable, BruchEditable_OfBruch_63F776FF, Bruch_$reflection } from "../Bruch.jsx";
import { IntInput_Error_6F29BBBB, IntInput__Clear_Z1FBCCD16, IntInput__WithInput_Z524259A4, IntInput__get_Value, IntInput, IntInput__get_HasValue, IntInput__get_ErrorMessage, Editable$2, IntInput_$reflection } from "../Input.jsx";
import { bool_type, union_type, int32_type, record_type } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Reflection.js";
import { Ausdruck } from "../Ausdruck.jsx";
import { TaskResultMsgModule_finish, TaskResultMsgModule_fail, TaskResultMsgModule_success, InputMsg_$reflection, TaskResultMsgModule_updateState } from "../Types.jsx";

export class FaktorState extends Record {
    constructor(OriginalBruch, AktuellerBruch, Faktor) {
        super();
        this.OriginalBruch = OriginalBruch;
        this.AktuellerBruch = AktuellerBruch;
        this.Faktor = Faktor;
    }
}

export function FaktorState_$reflection() {
    return record_type("MatheApp.Domain.BruchKuerzen.FaktorState", [], FaktorState, () => [["OriginalBruch", Bruch_$reflection()], ["AktuellerBruch", Bruch_$reflection()], ["Faktor", IntInput_$reflection()]]);
}

export class ZählerState extends Record {
    constructor(OriginalBruch, AktuellerBruch, Faktor, Zähler) {
        super();
        this.OriginalBruch = OriginalBruch;
        this.AktuellerBruch = AktuellerBruch;
        this.Faktor = (Faktor | 0);
        this.Zähler = Zähler;
    }
}

export function ZählerState_$reflection() {
    return record_type("MatheApp.Domain.BruchKuerzen.ZählerState", [], ZählerState, () => [["OriginalBruch", Bruch_$reflection()], ["AktuellerBruch", Bruch_$reflection()], ["Faktor", int32_type], ["Zähler", IntInput_$reflection()]]);
}

export class NennerState extends Record {
    constructor(OriginalBruch, AktuellerBruch, Faktor, Zähler, Nenner) {
        super();
        this.OriginalBruch = OriginalBruch;
        this.AktuellerBruch = AktuellerBruch;
        this.Faktor = (Faktor | 0);
        this.Zähler = (Zähler | 0);
        this.Nenner = Nenner;
    }
}

export function NennerState_$reflection() {
    return record_type("MatheApp.Domain.BruchKuerzen.NennerState", [], NennerState, () => [["OriginalBruch", Bruch_$reflection()], ["AktuellerBruch", Bruch_$reflection()], ["Faktor", int32_type], ["Zähler", int32_type], ["Nenner", IntInput_$reflection()]]);
}

export class AbgeschlossenState extends Record {
    constructor(OriginalBruch, Ergebnis) {
        super();
        this.OriginalBruch = OriginalBruch;
        this.Ergebnis = Ergebnis;
    }
}

export function AbgeschlossenState_$reflection() {
    return record_type("MatheApp.Domain.BruchKuerzen.AbgeschlossenState", [], AbgeschlossenState, () => [["OriginalBruch", Bruch_$reflection()], ["Ergebnis", Bruch_$reflection()]]);
}

export class State extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FaktorState", "ZählerState", "NennerState", "AbgeschlossenState"];
    }
}

export function State_$reflection() {
    return union_type("MatheApp.Domain.BruchKuerzen.State", [], State, () => [[["Item", FaktorState_$reflection()]], [["Item", ZählerState_$reflection()]], [["Item", NennerState_$reflection()]], [["Item", AbgeschlossenState_$reflection()]]]);
}

export function State__get_AktuellerBruch(this$) {
    switch (this$.tag) {
        case 1:
            return BruchEditable_OfBruch_63F776FF(this$.fields[0].AktuellerBruch);
        case 2:
            return BruchEditable_OfBruch_63F776FF(this$.fields[0].AktuellerBruch);
        case 3:
            return BruchEditable_OfBruch_63F776FF(this$.fields[0].OriginalBruch);
        default:
            return BruchEditable_OfBruch_63F776FF(this$.fields[0].AktuellerBruch);
    }
}

export function State__get_Faktor(this$) {
    switch (this$.tag) {
        case 1:
            return new Editable$2(1, [this$.fields[0].Faktor]);
        case 2:
            return new Editable$2(1, [this$.fields[0].Faktor]);
        case 3: {
            const a = this$.fields[0];
            return new Editable$2(1, [~~(a.OriginalBruch.Zähler / a.Ergebnis.Zähler)]);
        }
        default:
            return new Editable$2(2, [this$.fields[0].Faktor]);
    }
}

export function State__get_NeuerBruch(this$) {
    switch (this$.tag) {
        case 1:
            return new BruchEditable(new Editable$2(2, [this$.fields[0].Zähler]), new Editable$2(0, []));
        case 2: {
            const n = this$.fields[0];
            return new BruchEditable(new Editable$2(1, [n.Zähler]), new Editable$2(2, [n.Nenner]));
        }
        case 3: {
            const a = this$.fields[0];
            return new BruchEditable(new Editable$2(1, [a.Ergebnis.Zähler]), new Editable$2(1, [a.Ergebnis.Nenner]));
        }
        default:
            return new BruchEditable(new Editable$2(0, []), new Editable$2(0, []));
    }
}

export function State__get_Format(this$) {
    return new Ausdruck(7, [State__get_AktuellerBruch(this$).Ausdruck, State__get_Faktor(this$).Ausdruck, State__get_NeuerBruch(this$).Ausdruck]);
}

export function State__get_Rückmeldung(this$) {
    switch (this$.tag) {
        case 1:
            return IntInput__get_ErrorMessage(this$.fields[0].Zähler);
        case 2:
            return IntInput__get_ErrorMessage(this$.fields[0].Nenner);
        case 3:
            return "Richtig!";
        default:
            return IntInput__get_ErrorMessage(this$.fields[0].Faktor);
    }
}

export function State__get_CanOk(this$) {
    switch (this$.tag) {
        case 1:
            return IntInput__get_HasValue(this$.fields[0].Zähler);
        case 2:
            return IntInput__get_HasValue(this$.fields[0].Nenner);
        case 3:
            return false;
        default:
            return IntInput__get_HasValue(this$.fields[0].Faktor);
    }
}

export function State__get_CanClear(this$) {
    return State__get_CanOk(this$);
}

export const initialState = new State(0, [new FaktorState(Bruch_Create_Z37302880(1, 1), Bruch_Create_Z37302880(1, 1), new IntInput(0, [undefined]))]);

export function create(random) {
    const original = Bruch_ErstelleZufälligenBruch_ZC341D2B(random);
    return new State(0, [new FaktorState(original, original, new IntInput(0, [undefined]))]);
}

function next(state) {
    let fs, zs, ns;
    return TaskResultMsgModule_updateState((state.tag === 0) ? ((fs = state.fields[0], new State(1, [new ZählerState(fs.OriginalBruch, fs.AktuellerBruch, IntInput__get_Value(fs.Faktor), new IntInput(0, [undefined]))]))) : ((state.tag === 1) ? ((zs = state.fields[0], new State(2, [new NennerState(zs.OriginalBruch, zs.AktuellerBruch, zs.Faktor, IntInput__get_Value(zs.Zähler), new IntInput(0, [undefined]))]))) : ((state.tag === 2) ? ((ns = state.fields[0], new State(0, [new FaktorState(ns.OriginalBruch, Bruch_Create_Z37302880(ns.Zähler, IntInput__get_Value(ns.Nenner)), new IntInput(0, [undefined]))]))) : state)));
}

function update(transform, state) {
    let inputRecord, inputRecord_1, inputRecord_2;
    switch (state.tag) {
        case 0: {
            const f = state.fields[0];
            return new State(0, [(inputRecord = f, new FaktorState(inputRecord.OriginalBruch, inputRecord.AktuellerBruch, transform(f.Faktor)))]);
        }
        case 1: {
            const z = state.fields[0];
            return new State(1, [(inputRecord_1 = z, new ZählerState(inputRecord_1.OriginalBruch, inputRecord_1.AktuellerBruch, inputRecord_1.Faktor, transform(z.Zähler)))]);
        }
        case 2: {
            const n = state.fields[0];
            return new State(2, [(inputRecord_2 = n, new NennerState(inputRecord_2.OriginalBruch, inputRecord_2.AktuellerBruch, inputRecord_2.Faktor, inputRecord_2.Zähler, transform(n.Nenner)))]);
        }
        default:
            return state;
    }
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CheckVollständig", "InputMsg", "Ok"];
    }
}

export function Msg_$reflection() {
    return union_type("MatheApp.Domain.BruchKuerzen.Msg", [], Msg, () => [[["Item", bool_type]], [["Item", InputMsg_$reflection()]], []]);
}

export function reduce(logger, state, action) {
    let matchResult, fs_1, istGekuerzt, ziffer, alles, fs_2, zs_1, ns_1;
    switch (state.tag) {
        case 1: {
            switch (action.tag) {
                case 1: {
                    switch (action.fields[0].tag) {
                        case 0: {
                            matchResult = 1;
                            ziffer = action.fields[0].fields[0];
                            break;
                        }
                        case 2: {
                            matchResult = 2;
                            alles = action.fields[0].fields[0];
                            break;
                        }
                        default:
                            matchResult = 7;
                    }
                    break;
                }
                case 2: {
                    if (IntInput__get_HasValue(state.fields[0].Zähler)) {
                        matchResult = 4;
                        zs_1 = state.fields[0];
                    }
                    else {
                        matchResult = 7;
                    }
                    break;
                }
                default:
                    matchResult = 7;
            }
            break;
        }
        case 2: {
            switch (action.tag) {
                case 1: {
                    switch (action.fields[0].tag) {
                        case 0: {
                            matchResult = 1;
                            ziffer = action.fields[0].fields[0];
                            break;
                        }
                        case 2: {
                            matchResult = 2;
                            alles = action.fields[0].fields[0];
                            break;
                        }
                        default:
                            matchResult = 7;
                    }
                    break;
                }
                case 2: {
                    if (IntInput__get_HasValue(state.fields[0].Nenner)) {
                        matchResult = 5;
                        ns_1 = state.fields[0];
                    }
                    else {
                        matchResult = 7;
                    }
                    break;
                }
                default:
                    matchResult = 7;
            }
            break;
        }
        case 3: {
            switch (action.tag) {
                case 1: {
                    switch (action.fields[0].tag) {
                        case 0: {
                            matchResult = 1;
                            ziffer = action.fields[0].fields[0];
                            break;
                        }
                        case 2: {
                            matchResult = 2;
                            alles = action.fields[0].fields[0];
                            break;
                        }
                        default:
                            matchResult = 7;
                    }
                    break;
                }
                case 2: {
                    matchResult = 6;
                    break;
                }
                default:
                    matchResult = 7;
            }
            break;
        }
        default:
            switch (action.tag) {
                case 1: {
                    switch (action.fields[0].tag) {
                        case 0: {
                            matchResult = 1;
                            ziffer = action.fields[0].fields[0];
                            break;
                        }
                        case 2: {
                            matchResult = 2;
                            alles = action.fields[0].fields[0];
                            break;
                        }
                        default:
                            matchResult = 7;
                    }
                    break;
                }
                case 2: {
                    if (IntInput__get_HasValue(state.fields[0].Faktor)) {
                        matchResult = 3;
                        fs_2 = state.fields[0];
                    }
                    else {
                        matchResult = 7;
                    }
                    break;
                }
                default: {
                    matchResult = 0;
                    fs_1 = state.fields[0];
                    istGekuerzt = action.fields[0];
                }
            }
    }
    switch (matchResult) {
        case 0:
            if (istGekuerzt && Bruch__IstGekürzt(fs_1.AktuellerBruch)) {
                return TaskResultMsgModule_success(new State(3, [new AbgeschlossenState(fs_1.OriginalBruch, fs_1.AktuellerBruch)]));
            }
            else {
                return TaskResultMsgModule_updateState(new State(0, [fs_1]));
            }
        case 1:
            return TaskResultMsgModule_updateState(update((_arg) => IntInput__WithInput_Z524259A4(_arg, ziffer), state));
        case 2:
            return TaskResultMsgModule_updateState(update((_arg_1) => IntInput__Clear_Z1FBCCD16(_arg_1, alles), state));
        case 3: {
            const f = IntInput__get_Value(fs_2.Faktor) | 0;
            if (Bruch__IstKürzbarMit_Z524259A4(fs_2.AktuellerBruch, f)) {
                return next(state);
            }
            else {
                return TaskResultMsgModule_fail(update((_arg_2) => IntInput_Error_6F29BBBB(Bruch__GetGgt(fs_2.AktuellerBruch), f, "Falsch"), state));
            }
        }
        case 4: {
            const z = IntInput__get_Value(zs_1.Zähler) | 0;
            const erwarteterZ = ~~(zs_1.AktuellerBruch.Zähler / zs_1.Faktor) | 0;
            if (z === erwarteterZ) {
                return next(state);
            }
            else {
                return TaskResultMsgModule_fail(update((_arg_3) => IntInput_Error_6F29BBBB(erwarteterZ, z, "Falsch"), state));
            }
        }
        case 5: {
            const n = IntInput__get_Value(ns_1.Nenner) | 0;
            const erwarteterN = ~~(ns_1.AktuellerBruch.Nenner / ns_1.Faktor) | 0;
            if (n === erwarteterN) {
                return next(state);
            }
            else {
                return TaskResultMsgModule_fail(update((_arg_4) => IntInput_Error_6F29BBBB(erwarteterN, n, "Falsch"), state));
            }
        }
        case 6:
            return TaskResultMsgModule_finish(state);
        default:
            return TaskResultMsgModule_updateState(state);
    }
}

